import "./src/style.css"
import "./src/limousine.css"
import "prismjs/themes/prism.css"
import "./src/style.css"
import "./src/limousine.css"
import "prismjs/themes/prism.css"

import * as React from "react"
import { AnimatePresence } from "framer-motion"

export const wrapPageElement = ({ element }) => (
  <AnimatePresence mode="wait">{element}</AnimatePresence>
)

export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
  const transitionDelay = 350

  if (location.hash) {
    return true
  }

  if (location.action === "PUSH") {
    window.setTimeout(() => window.scrollTo(0, 0), transitionDelay)
  } else {
    const savedPosition = getSavedScrollPosition(location)
    window.setTimeout(
      () => window.scrollTo(...(savedPosition || [0, 0])),
      transitionDelay
    )
  }
  return false
}